import DataType from '../types/DataType.js';

const getDataTypeIcon = (dataType) => {
    switch (dataType) {
        case DataType.Boolean:
            return "pi pi-circle";
        case DataType.DateTime:
            return "pi pi-calendar";
        case DataType.Number:
            return "pi pi-th-large";
        case DataType.Text:
            return "pi pi-chevron-circle-up";
        case DataType.Uuid:
            return "pi pi-clock";
        default:
            return "pi pi-question-circle";
    }
};

export { getDataTypeIcon };
//# sourceMappingURL=utils.js.map
